import { handleActions } from "redux-actions";

import { TourState } from "src/interfaces/joyrideState.interface";
import {
  TOUR,
  SET_STEP_TYPE,
  SET_OPEN,
  SET_CURRENT_STEP,
  SET_PENDING_STEP,
  SET_DIALOG_READY,
} from "src/store/common";
import produce from "immer";

const initialState: TourState = {
  stepType: "",
  currentStep: 0,
  open: false,
  pendingStep: null,
  dialogReady: false,
};

export const tourReducer = handleActions<TourState, any>(
  {
    [TOUR + SET_STEP_TYPE]: (state, { payload }) =>
      produce(state, (draft) => {
        draft.stepType = payload;
      }),
    [TOUR + SET_OPEN]: (state, { payload }) =>
      produce(state, (draft) => {
        draft.open = payload;
      }),
    [TOUR + SET_CURRENT_STEP]: (state, { payload }) =>
      produce(state, (draft) => {
        draft.currentStep = payload;
      }),
    [TOUR + SET_PENDING_STEP]: (state, { payload }) =>
      produce(state, (draft) => {
        draft.pendingStep = payload;
      }),
    [TOUR + SET_DIALOG_READY]: (state, { payload }) =>
      produce(state, (draft) => {
        draft.dialogReady = payload;
      }),
  },
  initialState
);
